import { Component, OnInit } from '@angular/core';
import { BasicNotificationElementComponent } from '../basic-notification-element/basic-notification-element.component';

@Component( {
    selector: 'ridango-basic-information-notification',
    templateUrl: './basic-information-notification.component.html',
    styleUrls: [ './basic-information-notification.component.scss' ]
} )
export class BasicInformationNotificationComponent extends BasicNotificationElementComponent implements OnInit {

    constructor() {
        super();
    }
    ngOnInit () {

        // tslint:disable-next-line:max-line-length
        this.title = this.notification.title ? this.notification.title : 'information';
        this.message = this.notification.message;
    }

}
